<template>
    <div v-if="!hideMe" :style="indent" >
        <div v-show="children.length" class="treeExpander" style="cursor: pointer" @click="doExpand">{{ isExpanded ? ' - ' : ' + ' }}</div>
        <div v-show="!children.length" class="treeExpander">&nbsp;</div>
        <input ref="cb" type="checkbox" @click="clicked" />
        <div class="treeNode left5 " :class="{bFilterHighlight: highlighted}"  @mouseover="hovering = true" @mouseleave="hovering = false"><span class="has-text-coolGreen"></span>{{listName}}</div>
        <tree ref="node" v-show="isExpanded" class="top2" v-for="(item, ind) in children" 
                :key="ind" 
                :listName="item.listName" 
                :children="item.children" 
                :depth="depth + 1" 
                :aliasTgtId="item.aliasTgtId"
                :id="item.id" 
                :currCardId="currCardId" 
                :selectedFromCopyCard="item.selectedFromCopyCard" 
                :hideMe="item.hideMe"
                :editWindow="editWindow"
                :collabId="item.collabId"
                :isCollab="item.isCollab"
                :caller="caller"
                :curr="curr"
                >
        </tree>
       
    </div>
</template>

<script>
    import { AZEventBus } from './AZEventBus'
    import bFactory from '../shared/bundleFactory.js'

    export default { 
        name: 'tree',
        props: ['listName', 'children', 'depth', 'id', 'currCardId', 'aliasTgtId', 'selectedFromCopyCard', 'editWindow', 'collabId', 'isCollab', 'caller', 'curr'],
        data: function(){
            return {
                isSelected: '',
                isExpanded: this.depth == 0 && this.caller != 'multi' ? true : false,
                highlighted: false,
                hovering: false,
                hideMe: false
            }
        },
        mounted(){
           
            var self = this;

           /*  setTimeout(function(){
                if(self.curr == self.id && self.curr != undefined){
                    self.$refs.cb.setAttribute('disabled', 'true')
                    self.$refs.cb.style.opacity = '0.5'
                }
            }, 5) */
            


           /*  let bundle = this.$root.app.bundles.find(e => {
                return e.id == this.id
            })

            for(let i=0; i < bundle.items.length; i++){
                if(bundle.items[i].id == this.currCardId){
                    this.isSelected = true;
                    if(this.depth > 0)
                        this.$parent.expandBranch()
                    break;
                }
            } */


            //this.checkIfSelected(true)

           

            AZEventBus.$on('filteredBundles', this.filteredBundlesHandler)

            AZEventBus.$on('collapseTrees', this.collapseTreesHandler)

            AZEventBus.$on('treesCheckIfSelected', this.treesCheckIfSelected)

            AZEventBus.$on('makeDim', this.makeDimHandler)
        },

        beforeDestroy: function(){
            var self = this;
            AZEventBus.$off('filteredBundles', this.filteredBundlesHandler)

            AZEventBus.$off('collapseTrees', this.collapseTreesHandler)

            AZEventBus.$off('treesCheckIfSelected', this.treesCheckIfSelected)

            AZEventBus.$off('makeDim', this.makeDimHandler)
        },

        methods: {

            filteredBundlesHandler: function(arr){
                var self = this
                let f = arr.findIndex(e => {
                    return e == self.id
                })

                if(f != -1){
                    if(self.depth > 0){
                        self.$parent.expandBranch()
                    }

                    this.highlighted = true

                } else {
                    this.highlighted = false
                }
            },

            collapseTreesHandler: function(msg){
                this.doCollapse()
                this.removeHighlight()
            },

            treesCheckIfSelected: function(msg){
                this.checkIfSelected()
            },

            makeDimHandler: function(msg){
                var self = this
                if(msg.id == self.id){
                    
                    if(msg.turnOn){
                        self.$refs.cb.checked = true
                        self.isSelected = true
                    } else {
                       
                        self.$refs.cb.checked = false
                        self.isSelected = false
                    }
                   
                }
            },

            clicked: function(){
                let msg = {};
                msg.aliasTgtId = this.aliasTgtId
                msg.wrapperId = this.id
                msg.collabId = this.collabId
                /* if(this.$refs.cb.checked == true){
                    msg.selected = true
                } else {
                    msg.selected = false
                } */
                AZEventBus.$emit('onTreeNodeClicked', msg)
            },
            doExpand: function(){
                this.isExpanded = !this.isExpanded
            },
            doCollapse: function(){
                this.isExpanded = false
            },
            removeHighlight: function(){
                this.highlighted = false
            },
            expandBranch: function(){
                this.isExpanded = true;
                if(this.depth > 0){
                    this.$parent.expandBranch()
                }
            },
            checkIfSelected: function(fromMounted){
                
                let bundle = this.$root.app.bundles.find(e => {
                    return e.id == this.id
                })

                for(let i=0; i < bundle.items.length; i++){
                    if(bundle.items[i].id == this.currCardId){
                        if(this.depth > 0)
                            this.$parent.expandBranch()
                            
                        if(fromMounted){
                            this.isSelected = true;
                        }
                        
                        break;
                    }
                }

                if(this.selectedFromCopyCard){
                    if(this.depth > 0)
                        this.$parent.expandBranch()
                        
                    if(fromMounted){
                        this.isSelected = true;
                    }
                        
                }
            },
           
            saveSub: function(bundleName){
 
                var self = this;
                var thisBundle;

                function w(data){
                    if(data == 'miimu limit exceeded'){
                        if(!self.$root.app.inApp)
                            self.$root.app.doShowModal('ModalUpg', {limit: 'b'})
                        else
                            self.$root.app.doShowModal('ModalOK', {message: `Congratulations! You've created a ton of bundles! To create more, please visit your account settings from any web browser.`})

                        return
                    }

                    let bId = data.response
                    

                    thisBundle = self.$root.app.bundles.find((e) => {
                        return e.id == self.id
                    })

                    let newBranch = thisBundle.branch.concat([bId])

                    let b = bFactory(bId, false, bundleName, newBranch)
                    b.collabId = self.collabId
                    self.$root.app.bundles.push(b);
                    
                    thisBundle.children.push(b)
                    self.doExpand()
                }

                function n(){
                    self.$root.app.closeModal()
                    self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support.'})
                }

                var checkLimits = this.$root.app.checkLimits

                self.$root.app.apiClient.post('subs/data/bundle', {checkLimits: checkLimits, name: bundleName, isRoot: false, targetBundle: this.aliasTgtId || self.id, p: null, collabId: this.collabId}, w, n);

            },
        },
        computed: {
            indent() {
                return this.depth == 0 ? '' : { transform: 'translate(30px)' }
            }
        }
    }
</script>